import React, { useState } from "react";
import { Form, Modal } from "reactstrap";
import "./ViewSenddataModal.scss";
import { useEffect } from "react";
import { isParsable, parseJsonRecursively } from "../../../../helperFunctions";

const ViewSentdataModal = ({ isViewsendDataModal, onCloseModal, data }) => {
  const [parsedData1, setParsedData1] = useState(null);
  const [parsedData2, setParsedData2] = useState(null);

  useEffect(() => {
    let parsedRequestBody = null;
    try {
      parsedRequestBody = isParsable(data?.notify_res)
        ? parseJsonRecursively(JSON.parse?.(data?.notify_res))
        : data?.notify_res;
    } catch (error) {
      console.error("Error parsing notify_res:", error);
    }
    setParsedData1(parsedRequestBody);

    try {
      const parsedResponseBody = isParsable(data?.send_notify_content)
        ? parseJsonRecursively(JSON.parse(data?.send_notify_content))
        : data?.send_notify_content;
      setParsedData2(parsedResponseBody);
    } catch (error) {
      console.error("Error parsing responseBody:", error);
    }
  }, [data?.notify_res, data?.send_notify_content]);

  return (
    <Form>
      <Modal
        isOpen={!!isViewsendDataModal}
        toggle={() => onCloseModal()}
        className="view-send-data-modal"
        centered={true}
      >
        <div className="modal-header">
          <h3 className="modal-title mt-0">View Send Data</h3>
          <i
            onClick={() => {
              onCloseModal();
            }}
            className="fa-solid fa-xmark"
          ></i>
        </div>
        <div className="modal-body w-100 json-style">
          <h5>Webhook Response Data</h5>
          <div className="webevent-sec mb-1 req_text_wrap requestContainer">
            <pre>{parsedData1 ? JSON.stringify(parsedData1, null, 2) : "No request body"}</pre>
          </div>
          <h5>Send Webhook Data</h5>
          <div className="webevent-sec mb-1 req_text_wrap requestContainer">
            <pre>{parsedData2 ? JSON.stringify(parsedData2, null, 2) : "No response body"}</pre>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

export default ViewSentdataModal;
